import React, { useState, useEffect, useMemo } from 'react';
import ErrorList from 'components/ErrorList';
import SimpleLoader from 'components/SimpleLoader/SimpleLoader';
import { ICreateWindowProps } from './CreateWindow.types';
import { CatalogEntry } from 'typings/models';

const CreateWindow = ({
  choices,
  isCreatingWindow,
  wallId,
  onCreate,
  onReset,
}: ICreateWindowProps) => {
  const [isEditing, setIsEditing] = useState<boolean>(false);
  const [material, setMaterial] = useState<string>();
  const [token, setToken] = useState<string>();
  const [type, setType] = useState<number>();
  const [catalogEntry, setCatalogEntry] = useState<CatalogEntry>();

  const ref = React.createRef<HTMLInputElement>();
  const focus = () => !!ref.current && ref.current.focus();

  useEffect(() => {
    !isEditing && onReset();
  }, [isEditing]);

  useEffect(() => {
    if (isCreatingWindow.status === 'SAVED') {
      setMaterial(undefined);
      setToken(undefined);
      setType(undefined);
      setCatalogEntry(undefined);
      focus();
    }
  }, [isCreatingWindow.status]);

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      create();
    }
    if (e.key === 'Escape') {
      setIsEditing(false);
    }
  };

  const create = useMemo(() => {
    return () =>
      onCreate(token || '', material || '', type || null, wallId, catalogEntry?.id || null);
  }, [token, material, type, wallId, catalogEntry]);

  if (isCreatingWindow.status === 'SAVING') {
    return <SimpleLoader />;
  } else if (isEditing) {
    return (
      <div>
        <ErrorList errors={isCreatingWindow.messages} errorField="token" />
        <input
          defaultValue={undefined}
          placeholder="Signatur"
          type="text"
          onChange={(e: React.FormEvent<HTMLInputElement>) => setToken(e.currentTarget.value)}
          onKeyDown={handleKeyDown}
        />
        <div>
          Fenster-Art:&nbsp;
          <ErrorList errors={isCreatingWindow.messages} errorField="type" />
          <select
            defaultValue={undefined}
            size={1}
            onChange={(e: React.FormEvent<HTMLSelectElement>) =>
              setType(parseInt(e.currentTarget.value, 10))
            }
          >
            <option value="">--- Bitte wählen --- </option>
            {choices.map((item) => (
              <option value={item[0]} key={item[1]}>
                {item[1]}
              </option>
            ))}
          </select>
        </div>
        <ErrorList errors={isCreatingWindow.messages} errorField="material" />

        <textarea
          defaultValue={undefined}
          placeholder="Beschreibung"
          onKeyDown={handleKeyDown}
          onChange={(e: React.FormEvent<HTMLTextAreaElement>) => setMaterial(e.currentTarget.value)}
        />
        <br />
        <button className="primary" onClick={create}>
          OK
        </button>
        <button className="secondary" onClick={() => setIsEditing(false)}>
          Abbrechen
        </button>
      </div>
    );
  }
  return (
    <button className="primary add-button" onClick={() => setIsEditing(true)}>
      Fenster hinzufügen
    </button>
  );
};

export default CreateWindow;
